import { render, staticRenderFns } from "./BuyBoxBundle.vue?vue&type=template&id=ca2e7502&scoped=true"
import script from "./BuyBoxBundle.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyBoxBundle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BuyBoxBundle.vue?vue&type=style&index=0&id=ca2e7502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2e7502",
  null
  
)

export default component.exports